import React from "react";
import ReactDOM from "react-dom";
import { AppHumaya } from "./AppHumaya";
import "./Styles/style.css";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <AppHumaya />
//   </React.StrictMode>
// );

ReactDOM.render(<AppHumaya />, document.getElementById("root"));

// createRoot(document.getElementById("root")).render(<AppHumaya />);
